import React from 'react';
import ReactDOM from 'react-dom';
// import App from './App';
import * as serviceWorker from './serviceWorker';
import AppRouter from './router/AppRouter'
import { Provider } from "react-redux";
import store  from './redux/store';
import '../src/common/common.css'
import '../src/common/iconfont.css'
ReactDOM.render( 
  <Provider store={store}>
    <AppRouter />
  </Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
